import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'

import BreadCrumbs from '~/encyclopedia/components/BreadCrumbs'
import { TopicData } from '~/types/theory'

export default function MessageBox({ breadcrumbs, h1 }: { breadcrumbs: TopicData[]; h1: string }): React.ReactElement {
  const { t } = useTranslation('drill')

  const Bee = (): React.ReactElement => {
    return (
      <SVGImage
        alt={t('DRilloTheBee')}
        imageClassName="absolute -top-12 -right-10 md:-top-4 md:-right-4 transform scale-50 md:scale-100"
        srcKey="math-drills/bee-detailed.svg"
      />
    )
  }

  return (
    <div className="z-10 relative mx-auto xl:mx-0 max-w-xl p-3 rounded shadow-large bg-white">
      <Bee />
      <div className="mb-2">
        <h1 className="text-h3 lg:text-h3 capitalize">{h1}</h1>
        <BreadCrumbs breadcrumbs={breadcrumbs} />
      </div>
      <p className="text-xs md:text-sm">
        {t('messageBoxIntro')} <HexagonBetweenParantheses />
        <br />
        {t('messageBoxParagraph')}
      </p>
    </div>
  )
}

function HexagonBetweenParantheses(): React.ReactElement {
  const { t } = useTranslation(['drill'])
  return (
    <span className="inline-flex items-baseline text-md md:text-lg">
      <SVGImage alt={t('drill:imageAlt.hexIcon')} imageClassName="h-5 md:h-8" srcKey="math-drills/hex-icon.svg" />.
    </span>
  )
}
